export const FETCH_STATISTICS_FORM_REQUEST = "FETCH_STATISTICS_FORM_REQUEST";
export const FETCH_STATISTICS_FORM_SUCCESS = "FETCH_STATISTICS_FORM_SUCCESS";
export const FETCH_STATISTICS_FORM_FAIL = "FETCH_STATISTICS_FORM_FAIL";

export const CREATE_STATISTICS_FORM_REQUEST = "CREATE_STATISTICS_FORM_REQUEST";
export const CREATE_STATISTICS_FORM_SUCCESS = "CREATE_STATISTICS_FORM_SUCCESS";
export const CREATE_STATISTICS_FORM_FAIL = "CREATE_STATISTICS_FORM_FAIL";
